import PropTypes from 'prop-types';
import QRScanner from './QRScanner';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button } from '@mui/material';

function ScanQRDialog({ classes, isOpen, title, onScan, onCancel }) {
  return (
    <Dialog
      open={isOpen}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <DialogContent>
        { isOpen && <QRScanner onScan={onScan} /> }
        {onCancel && (
          <Button
            onClick={onCancel}
            color='primary'
            variant='contained'
            fullWidth
            className={classes.newButton}
          >
            Cancel
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
}

ScanQRDialog.propTypes = {
  classes: PropTypes.any,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  onScan: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
};

export default ScanQRDialog;
